import BaseScreen from 'components/base-screen';
import Header from 'components/header';
import iconReit from '../../assets/images/itreit_logo.jpg';

import iconSell from '../../assets/images/apartment-sell.svg';
import iconFavorite from '../../assets/images/heart-filled-wite.svg';
import iconBuy from '../../assets/images/apartment-buy.svg';
import iconCalculator from '../../assets/images/calculator.svg';

import styles from './styles.module.scss';
import { useNavigate } from 'react-router-dom';
import { BuyApartmentFlowPaths, CommonPaths, SellApartmentFlowPaths } from 'routes';
import useBoundStore from 'store';
import { APIUserType } from 'api/types';

const StartPage = () => {
  const navigate = useNavigate();
  const isClient = useBoundStore.getState()?.user?.type === APIUserType.CLIENT;

  return (
    <BaseScreen title='Добро пожаловать' hideBackButton>
      <section className={styles.homePage}>
        <div className={styles.homePage__container}>
          <div className={styles.homePage__main}>
            <img className={styles.homePage__reit} src={iconReit} width={350} alt='Логотип reit' />
            <Header className={styles.homePage__text} text='Сервис умных сделок с недвижимостью' />
            <div className={styles.homePage__vContainer}>
              <p className={styles.homePage__version}>Бeта-тест</p>
            </div>
          </div>

          <div className={styles.homePage__footer}>
            <div
              className={styles.homePage__item}
              onClick={() => {
                navigate(BuyApartmentFlowPaths.apartmentFavorites);
              }}
            >
              <img src={iconFavorite} alt='favorites' />
              <span>Избранное</span>
            </div>

            <div
              className={styles.homePage__item}
              onClick={() => {
                navigate(CommonPaths.estimate);
              }}
            >
              <img src={iconCalculator} alt='estimate' />
              <span>Оценка</span>
            </div>

            {!isClient && (
              <div
                className={styles.homePage__item}
                onClick={() => {
                  navigate(BuyApartmentFlowPaths.chooseMode);
                }}
              >
                <img src={iconBuy} alt='find' />
                <span>Поиск</span>
              </div>
            )}
            {!isClient && (
              <div
                className={styles.homePage__item}
                onClick={() => {
                  navigate(SellApartmentFlowPaths.mainSellChooseMode);
                }}
              >
                <img src={iconSell} alt='sell' />
                <span>Продажа</span>
              </div>
            )}
          </div>
        </div>
      </section>
    </BaseScreen>
  );
};

export default StartPage;
